import QueryService from '@/services/query'
import { VUE_APP_ROOT_API } from '@/helpers/env'

export default {
  getUsersStats: async function() {
    const response = await QueryService.get(`${VUE_APP_ROOT_API}/statsapi/getuserstats`)
    return await response.json()
  },
  getBusinessStats: async function() {
    const response = await QueryService.get(`${VUE_APP_ROOT_API}/statsapi/getbusinessstats`)
    return await response.json()
  },
  getGatheringsStats: async function() {
    const response = await QueryService.get(`${VUE_APP_ROOT_API}/statsapi/getgatheringstats`)
    return await response.json()
  },
  getEntrepreneursStats: async function() {
    const response = await QueryService.get(`${VUE_APP_ROOT_API}/statsapi/getentrepreneurstats`)
    return await response.json()
  },
}
